import { useState } from 'react';
import { useQuery } from 'react-query';
import { showSnackBarMessage } from 'utils/helperFunctions';
import { useToaster } from 'context/SnackbarContext';
import { GET_INTROS_CONFIG } from 'Services/apiKeys';
import { getIntrosConfig } from 'Services/apiFunctions';

export const useIntrosData = (authToken, setLoading) => {
    const { setSnackbar } = useToaster();
    const [introsConfig, setIntrosConfig] = useState({
        favoriteFood: false,
        languages: false,
    });

    useQuery([GET_INTROS_CONFIG, authToken], getIntrosConfig, {
        onSuccess: (data) => {
            const introFormSettings = data?.userIntroMessage?.introFormSettings;
            setIntrosConfig({
                favoriteFood: introFormSettings?.formFields?.favoriteFood,
                languages: introFormSettings?.formFields?.languages,
            });
            setLoading(false);
        },
        onError: (err) => {
            showSnackBarMessage(setSnackbar, 'error', err?.message);
        },
    });

    return introsConfig;
};
